import { AlertCircle, AlertTriangle } from "lucide-react";
import type { AnalyticsInputWarningKind } from "../../lib/analyticsFeeds";

/**
 * The marker for one analytics-input warning.
 *
 * Icon and colour together, never one of them alone. The same `AlertTriangle` is
 * paired with red elsewhere in this codebase, so the shape settles nothing by
 * itself; and a colour by itself is not read at all in greyscale or by a reader
 * who cannot separate red from amber. A refusal stops the run and a shortfall
 * does not, which is the distinction that has to survive both.
 *
 * One component for the sentence under the table and for the row's count, so the
 * same file cannot be drawn as a refusal in one place and a shortfall in the
 * other. It carries its own colour rather than inheriting one, because the two
 * sit on differently coloured surfaces.
 *
 * Hidden from assistive technology, because neither site leaves the glyph as the
 * only place the kind is stated: under the table it marks a sentence that says
 * in words which of the two this is, and on the row the count's spoken long form
 * leads with `ANALYTICS_INPUT_WARNING_TEXT` for the kind drawn here. Named as
 * well, it would say the same thing a second time.
 */
export function AnalyticsInputWarningIcon({
  kind,
}: {
  kind: AnalyticsInputWarningKind;
}) {
  if (kind === "refusal") {
    return (
      <AlertCircle
        aria-hidden="true"
        className="mt-0.5 h-3 w-3 shrink-0 text-red-700"
      />
    );
  }
  return (
    <AlertTriangle
      aria-hidden="true"
      className="mt-0.5 h-3 w-3 shrink-0 text-amber-500"
    />
  );
}
